// Lent from https://github.com/Hotell/rex-tils

/**
 * use this type definition instead of `Function` type constructor
 */
export type AnyFunction = (...args: any[]) => any;
/**
 * simple alias to save you keystrokes when defining JS typed object maps
 */
export interface IStringMap<T> {
    [key: string]: T;
}

export type ActionsUnion<A extends IStringMap<AnyFunction>> = ReturnType<A[keyof A]>;

/**
 * Action can exists only in 2 shapes. type only or type with payload
 */
type Actions<T extends string = string, P = undefined> = P extends undefined
    ? Readonly<{ type: T; payload?: P }>
    : Readonly<{ type: T; payload: P }>;

export function createAction<T extends string>(type: T): Actions<T>;
export function createAction<T extends string, P>(
    type: T,
    payload: P
    ): Actions<T, P>;
export function createAction<T extends string, P>(type: T, payload?: P) {
    return payload === undefined ? { type } : { type, payload };
}